import { render, staticRenderFns } from "./cadastre.vue?vue&type=template&id=619a990f&scoped=true"
import script from "./cadastre.vue?vue&type=script&lang=js"
export * from "./cadastre.vue?vue&type=script&lang=js"
import style0 from "./cadastre.vue?vue&type=style&index=0&id=619a990f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619a990f",
  null
  
)

export default component.exports